import { createFileRoute } from '@tanstack/react-router';

import { BrandsPage } from '../features/campaigns/brands/BrandsPage';
import { brandsRouteSearchSchema } from '../features/campaigns/brands/brandsRouteSearch';

export const Route = createFileRoute('/campaigns/brands')({
  validateSearch: brandsRouteSearchSchema,
  component: BrandsPage,
});
